var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#DD0606"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 9.5H21.5V11H20V20.75C20 21.1642 19.6642 21.5 19.25 21.5H8.75C8.33579 21.5 8 21.1642 8 20.75V11H6.5V9.5H10.25V7.25C10.25 6.83579 10.5858 6.5 11 6.5H17C17.4142 6.5 17.75 6.83579 17.75 7.25V9.5ZM18.5 11H9.5V20H18.5V11ZM11.75 13.25H13.25V17.75H11.75V13.25ZM14.75 13.25H16.25V17.75H14.75V13.25ZM11.75 8V9.5H16.25V8H11.75Z",
    fill: "#DD0606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.89e94dd8a0eaa219e2e69f1a3a6cc653.svg";
export { ForwardRef as ReactComponent };